import React, { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination';
import { Alert, TaxOverviewService } from '../../services';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-loading-skeleton/dist/skeleton.css';
import ConfirmationPop from '../../components/ConfirmationPop';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import moment from 'moment';
import { ProcessingIcon } from '../../components/icons/IconProvider';
import NoDataFound from '../../components/NoDataFound';
import { formatValue } from '../../utils/Helper';
import TableComponent from '../../components/TableComponent';
import SearchInput from '../../components/SearchInput';

const TaxOverview = () => {
  const [isTaxLoader, setTaxLoader] = useState(false);
  const [generateTaxLoader, setGenerateTaxLoader] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  useState(null);
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });

  const [taxOverviewList, setTaxOverviewList] = useState([]);
  const [commonSearch, setCommonSearch] = useState('');
  const [filterData, setFilterData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    year: '',
  });
  const [isCommonConfirmationPop, setCommonConfirmationPop] = useState(false);
  const [isConfirmationPopData, setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });

  useEffect(() => {
    (async () => {
      await getTaxOverviewList();
    })();
  }, [filterData, commonSearch]);

  const generateTaxOverview = async () => {
    try {
      setTaxLoader(true);
      let resp = await TaxOverviewService.generateTaxOverview();
      if (resp.status === 'failure') {
        setTaxLoader(false);
        Alert.error(resp.message);
        return false;
      }
      Alert.success(resp.message);
      getTaxOverviewList();
      setTaxLoader(false);
    } catch (error) {
      setTaxLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  const getTaxOverviewList = async () => {
    try {
      setTaxLoader(true);
      let resp = await TaxOverviewService.getListTaxOverview(
        filterData.perPage,
        filterData.page,
        filterData.commonSearch,
        filterData.year,
      );
      if (resp.status === 'failure') {
        setTaxLoader(false);
        Alert.error(resp.message);
        return false;
      }

      if (resp.data.records.length > 0 && btnDisable === false) {
        setBtnDisable(true);
      }
      setTaxOverviewList(resp.data.records);
      setPagination({
        totalPages: resp.data.pagination.totalPages,
        currentPage: resp.data.pagination.page,
      });
      setTaxLoader(false);
    } catch (error) {
      setTaxLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchDataTaxOverview = (searchValue) => {
    setFilterData({
      ...filterData,
      commonSearch: searchValue,
    });
  };

  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterData({
      ...filterData,
      page: current,
    });
  };

  const handleSelectChange = () => {
    setConfirmationPopData({
      FirstText: 'Generate Tax Overview',
      SecondText: 'Are you sure you want to generate tax overview?',
      FirstButton: 'No',
      secondButton: 'Yes',
      slug: 'redirect',
    });
    setCommonConfirmationPop(true);
  };

  const confirmationPopHandel = async (confirmed) => {
    setCommonConfirmationPop(false);
    if (confirmed) {
      setGenerateTaxLoader(true);
      await generateTaxOverview();
      setGenerateTaxLoader(false);
    }
  };

  const formattedDate = moment().subtract(1, 'years').startOf('year');
  const yearOfTaxGeneration = formattedDate.format('YYYY');
  let toolTipContent;
  if (btnDisable) {
    toolTipContent = `Tax overview for ${yearOfTaxGeneration} already generated`;
  } else {
    toolTipContent = `Generate tax overview for ${yearOfTaxGeneration}`;
  }

  const tableConfig = {
    columns: {
      user_name: {
        title: 'USER NAME',
        render: (data) => {
          return data?.user?.full_name || 'NA';
        },
      },
      balance_as_of_jan_1: {
        title: 'BALANCE AS OF JAN 1',
        render: (data) => {
          return (
            formatValue(data?.year_start_balance, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
      balance_as_of_dec_31: {
        title: 'BALANCE AS OF DEC 31',
        render: (data) => {
          return (
            formatValue(data?.year_end_balance, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
      interest_received: {
        title: 'INTEREST RECEIVED',
        render: (data) => {
          return (
            formatValue(data?.total_interest, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
      dividend_received: {
        title: 'DIVIDEND RECEIVED',
        render: (data) => {
          return (
            formatValue(data?.total_devidend, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
    },
    data: taxOverviewList,
  };

  return (
    <div>
      <div className="grid grid-cols-2 my-4">
        <h4 className="">Tax Overview</h4>
        <div className="flex justify-end items-center"></div>
      </div>
      <div className="mt-3 w-full bg-brandGray px-5 py-4 rounded-xl">
        <div className="">
          <div className="w-full bg-brandGray px-4 md:px-5 py-2 rounded-xl">
            <div className="flex justify-end gap-3">
              <div className="flex sm:inline-flex relative mb-2 sm:mb-0">
                <SearchInput
                  name="commonSearch"
                  id="commonSearch"
                  placeholder="Search By User name"
                  onChange={(e) => {
                    searchDataTaxOverview(e.target.value);
                    setCommonSearch(e.target.value);
                  }}
                  value={commonSearch}
                />
              </div>

              <div>
                <button
                  data-tooltip-id="generateTaxOverview"
                  className={`rounded ${
                    btnDisable
                      ? 'bg-gray-400 cursor-not-allowed'
                      : '  bg-lime-500'
                  } text-black`}
                  onClick={() => handleSelectChange()}
                  disabled={btnDisable}
                >
                  <span className="text-sm font-medium">
                    {' '}
                    {generateTaxLoader ? (
                      <div className="flex items-center gap-2">
                        <ProcessingIcon />
                        Generating Tax Overview
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        Generate Tax Overview
                      </div>
                    )}
                  </span>
                </button>
                <ReactTooltip
                  id="generateTaxOverview"
                  place="top"
                  content={toolTipContent}
                />
              </div>
            </div>

            <div className="flex flex-col relative overflow-x-auto w-full">
              <TableComponent
                tableConfig={tableConfig}
                isListLoader={isTaxLoader}
                isList={taxOverviewList}
              />
              {taxOverviewList &&
                taxOverviewList?.length > 0 &&
                isTaxLoader === false && (
                  <Pagination
                    total={isPagination.totalPages}
                    current={isPagination.currentPage}
                    pagination={(crPage) => handlePagination(crPage)}
                  />
                )}
              {taxOverviewList &&
                taxOverviewList.length === 0 &&
                isTaxLoader === false && (
                  <>
                    <NoDataFound />
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
      <ConfirmationPop
        isPop={isCommonConfirmationPop}
        setPop={setCommonConfirmationPop}
        functionCall={confirmationPopHandel}
        FirstText={isConfirmationPopData.FirstText}
        secondText={isConfirmationPopData.SecondText}
        FirstButton={isConfirmationPopData.FirstButton}
        secondButton={isConfirmationPopData.secondButton}
        slug={isConfirmationPopData.slug}
      />
    </div>
  );
};

export default TaxOverview;
